import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
// import Stores from '../../components/Stores';
import { Container, Message, Breadcrumbs, Title, Section, Loader } from '../../modules/modules';
import { INavLink } from '../../interfaces/interfaces';
import NotFound from '../../pages/NotFound';

interface IStaticPageProps extends RouteComponentProps<{ language: string }> {
  data: any;
}

interface IStaticPageState {
  loaded: boolean;
}

class TextPage extends React.Component<IStaticPageProps> {
  public state: IStaticPageState;

  public static getDerivedStateFromProps(props: IStaticPageProps, state: IStaticPageState) {
    if (!props.data.loading && !state.loaded) {
      return {
        ...state,
        loaded: true
      };
    }

    return state;
  }

  constructor(props: IStaticPageProps) {
    super(props);

    this.state = {
      loaded: false
    };
  }

  render() {
    const staticDocument = this.props.data.staticDocument;
    const { language } = this.props.match.params;

    let breadcrumbsLinks: INavLink[] = [];

    if (staticDocument) {
      breadcrumbsLinks = [{ value: 'Úvod' }, { value: staticDocument.title }];
    }

    return (
      <React.Fragment>
        {!this.state.loaded && <Loader />}

        {this.state.loaded &&
          (!staticDocument ?
            (
              <NotFound />
            ) :
            (
              <div className="textPage">
                {this.state.loaded && (
                  <React.Fragment>
                    <Breadcrumbs links={breadcrumbsLinks} />

                    <Container type="md" pd={2}>
                      <div className="boundaries">
                        <Section type="textPage">
                          <div dangerouslySetInnerHTML={{ __html: staticDocument.html[language] }} />
                        </Section>
                      </div>
                    </Container>
                  </React.Fragment>
                )}
              </div>
            )
          )
        }
        {/* <Stores /> */}
      </React.Fragment>
    );
  }
}

export default withRouter(TextPage);



// WEBPACK FOOTER //
// ./src/pages/TextPage/TextPage.tsx